<template>
  <div class="" v-loading="loading">
    <!--贴片-->
    <patch :data="data" v-if="isShowPatch" />
    <!--面包屑-->
    <!-- <div class="indexContainer" v-if="Number(level) === 2">
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }"><i class="iconfont icon-shouye"></i> 当前位置：首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{parentTitle}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!--单页-->
    <div class="indexContainer" v-if="isShowBlock">
      <div v-html="item.content"></div>
    </div>
    <!--列表-->

    <div class="indexContainer" v-if="isShowList">
      <template v-if="Number(model) === 2">
        <list2 :newsData="newsData" />
      </template>
      <template v-if="Number(model) === 3">
        <list3 :newsData="newsData" />
      </template>
      <template v-if="Number(model) === 4">
        <list4 :newsData="newsData" />
      </template>
      <template v-if="Number(model) === 5">
        <list5 :newsData="newsData" />
      </template>
    </div>
    <!--选项卡-->
    <div class="indexContainer" v-if="isShowTabList">
      <div class="productCenterMain">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="item.name" :name="'tabIndex' + index" v-for="(item, index) in list" :key="index">
            <!-- {{ item.model }} -->
            <template v-if="item.model === 'all'">
              <!-- <listAll :newsData="{id: 'all', languageId: item.languageId}" /> -->
              <list2 :newsData="{ id: 'all', languageId: item.languageId }" v-if="Number(list[1].model) === 2" />
              <list3 :newsData="{ id: 'all', languageId: item.languageId }" v-if="Number(list[1].model) === 3" />
              <list4 :newsData="{ id: 'all', languageId: item.languageId }" v-if="Number(list[1].model) === 4" />
              <list5 :newsData="{ id: 'all', languageId: item.languageId }" v-if="Number(list[1].model) === 5" />
            </template>
            <template v-if="Number(item.model) === 2">
              <list2 :newsData="{ id: item.id, languageId: item.languageId }" />
            </template>
            <template v-if="Number(item.model) === 3">
              <list3 :newsData="{ id: item.id, languageId: item.languageId }" />
            </template>
            <template v-if="Number(item.model) === 4">
              <list4 :newsData="{ id: item.id, languageId: item.languageId }" />
            </template>
            <template v-if="Number(item.model) === 5">
              <list5 :newsData="{ id: item.id, languageId: item.languageId }" />
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { getModule, getContent } from '@/api/inner.js';
import Patch from '../common/components/patch.vue';
import ListAll from '../item/listAll';
import List2 from '../item/list2';
import List3 from '../item/list3';
import List4 from '../item/list4';
import List5 from '../item/list5';
export default {
  components: {
    Patch,
    ListAll,
    List2,
    List3,
    List4,
    List5,
  },
  data() {
    return {
      loading: false,
      isShowBlock: false,
      isShowList: false,
      isShowTabList: false,
      isShowPatch: false,
      activeName: 'tabIndex0',
      level: '',
      parentTitle: '',
      title: '',
      model: '',
      id: '',
      data: [],
      item: {},
      list: [],
      newList: [],
      newsData: {},
      base: this.$store.getters.base
    }
  },
  created() {
    this.isShowBlock = false;
    this.isShowList = false;
    this.isShowTabList = false;
    this.isShowPatch = false;
    this.getInfo();

  },
  destroyed() {
    localStorage.removeItem('name')
  },
  methods: {
    async getInfo() {
      // document.title = localStorage.getItem('name') + '-' + localStorage.getItem('titleSuffix');
      document.title = this.base.name + '-' + (this.base.titleSuffix || '');
      let head = document.getElementsByTagName('head');
      let meta = document.createElement('meta');
      document.querySelector('meta[name="keywords"]').setAttribute('content',this.base.keyword||'')
      if (this.base.description) {
        document.querySelector('meta[name="description"]').setAttribute('content', this.base.description)
      } else {
        document.querySelector('meta[name="description"]').setAttribute('content', this.base.keyword)
      }
      head[0].appendChild(meta)
      const routeQuery = this.$route.query;
      // this.level = routeQuery.level;
      this.getModule(routeQuery.id)
      this.getData(routeQuery.id)
      // if(Number(routeQuery.level) === 2) {
      // let localName = JSON.parse(localStorage.getItem('location')).split('/');
      // this.parentTitle = localName[0];
      // this.title = localName[1];
      // if(Number(routeQuery.type) === 2) {
      //   this.getData(routeQuery.id, 2)
      // } else {
      //   if(Number(routeQuery.model) === 6) this.getData(routeQuery.id, 1);
      //   if([2,3,4,5].includes(Number(routeQuery.model))) {
      //     this.isShowList = true;
      //     this.newsData.id = routeQuery.id;
      //     this.newsData.languageId = routeQuery.languageId;
      //     this.model = routeQuery.model;
      //   }
      // }
      // }
    },
    // 获取贴片
    async getModule(id) {
      this.loading = true;
      await getModule(id).then(res => {
        this.loading = false;
        this.data = res.data || [];
        this.isShowPatch = true;
      })
    },
    // 获取栏目内容
    async getData(id) {
      await getContent(id).then(res => {
        if(res.data.name){
          document.title = res.data.name + ' ' +  this.base.name + '-' + (this.base.titleSuffix || '');
        }
        const model = res.data.model
        // 如果是单页
        if (model === 6) {
          this.item = res.data;
          this.isShowBlock = true;
          return
        }
        // 如果是列表
        if ([2, 3, 4, 5].includes(model)) {
          this.isShowList = true;
          this.newsData.id = id;
          this.newsData.languageId = res.data.languageId;
          this.model = res.data.model;
          return
        }

        // 如果是一级目录
        if(model===1 && res.data.parentId){
          this.getTabs(res.data.childs)
        }
      })
    },
    // 获取选项卡栏目列表列表
    async getTabs(data) {
      // const item = JSON.parse(localStorage.getItem('item'));
      let arrData = [];
      for (let i of data) {
        if (i.isNav === 1) {
          arrData.push(i)
        }
      }
      if (arrData.length > 1) {
        const arr = [{ name: '全部', model: 'all', languageId: this.$route.query.languageId }]
        this.list = [...arr, ...arrData]
      } else {
        this.list = [...data]
      }
      this.isShowTabList = true;
    },
    // 选项卡切换
    handleClick(tab, event) {
    }
  },
  watch: {
    $route(val) {
      this.isShowBlock = false;
      this.isShowList = false;
      this.isShowTabList = false;
      this.activeName = 'tabIndex0';
      this.getInfo();
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/innerPager/innerPager.vue